// Presentation only: callers must supply the committed backend result.
// Keep this contract identical in CRM and native; never infer success from checkout opening.
export function createCelebrationStore() {
  let queue = [];
  const listeners = new Set(), seen = new Set();
  const notify = () => listeners.forEach(listener => listener());
  return {
    subscribe: listener => { listeners.add(listener); return () => listeners.delete(listener); },
    getSnapshot: () => queue[0] || null,
    dismiss: () => { queue = queue.slice(1); notify(); },
    confirm: (result, { kind, amount, eventKey } = {}) => {
      if (result?.success !== true || !['trial', 'subscription', 'collection'].includes(kind)) return false;
      const received = Number(amount);
      if (kind === 'collection' && (!Number.isFinite(received) || received <= 0)) return false;
      if (eventKey && seen.has(eventKey)) return false;
      if (eventKey) { seen.add(eventKey); if (seen.size > 100) seen.delete(seen.values().next().value); }
      const message = kind === 'trial'
        ? { title: 'Welcome to HostelDesk!', subtitle: 'Your free trial is active.', description: 'Your next chapter starts here. Bring your rooms, residents and collections together.', action: 'Let’s get started' }
        : kind === 'subscription'
          ? { title: 'Welcome aboard!', subtitle: 'Payment successful. Your plan is active.', description: 'Thanks for choosing HostelDesk. You’re ready to keep your hostel running smoothly.', action: 'Let’s get started' }
          : { title: 'Payment recorded!', subtitle: `₹${received.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} received`, description: 'The collection has been saved successfully. You can continue managing your hostel.', action: 'Done' };
      queue = [...queue, { ...message, kind, eventKey }];
      notify();
      return true;
    },
  };
}
export const paymentCelebrations = createCelebrationStore();
export const celebrateConfirmed = (result, details) => paymentCelebrations.confirm(result, details);
export const celebratePaidDeposit = (result, record, previous) => {
  if (record?.transactionType !== 'charge' || record.status !== 'paid' ||
      (previous?.transactionType === 'charge' && previous.status === 'paid')) return false;
  return celebrateConfirmed(result, { kind: 'collection', amount: record.amount, eventKey: `deposit:${record._id}:paid` });
};
